import { Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../../assets/Images/icons/icon-back';
import DayLeftToolTip from '../../../components/Shared/tooltip/dayleft';
import { ROUTER } from '../../../constants/router';
import ConsentService from '../../../services/Consent.service';
import Card from './components/Card';

function DetailConsent() {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();

    const [detailConsentList, setDetailConsentList] = useState();

    const getDetailConsent = async () => {
        try {
            const { data } = await ConsentService.searchManageConsent({
                identity: id,
            });
            await setDetailConsentList(data?.resultData?.result);
        } catch (error) {}
    };

    useEffect(() => {
        getDetailConsent();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="title flex">
                <div
                    className="cursor-pointer mr-3"
                    onClick={() => {
                        navigate(
                            `${ROUTER.CONSENT_MANAGEMENT.MANANGE_CONSENT}`
                        );
                    }}
                >
                    <IconBack />
                </div>
                {t('Consent.DetailConsent')}
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Consent Management')} / {t('Manage Consent')} /{' '}
                </span>
                <span>{t('Consent.DetailConsent')}</span>
            </div>
            <div className="flex justify-between pt-5">
                <div className="flex-col">
                    <div className="text-[#7B67FB] text-xl font-semibold">
                        {id}
                    </div>
                    <div className="text-[#65707A] text-sm font-semibold">
                        {t('TotalItems', { length: detailConsentList?.length })}
                    </div>
                </div>
                <div className="flex justify-end">
                    <DayLeftToolTip />
                </div>
            </div>
            <Spin spinning={!detailConsentList?.length}>
                <div className="pt-5 space-y-5">
                    {detailConsentList?.map((item) => (
                        <Card
                            key={item?.consentTxnGroupId}
                            item={item}
                            getDetailConsent={getDetailConsent}
                        />
                    ))}
                </div>
            </Spin>
        </>
    );
}

export default DetailConsent;
